import { useTranslation } from 'react-i18next';
import { Button } from '@app/shared/ui/atoms/Common';
import { useLogout } from '@/app/shared/hooks/useLogout';

export function LogOutButton() {
  const { t } = useTranslation();
  const { handleLogout, isLoading } = useLogout();

  return (
    <Button variant="tertiary" className="mt-3 shrink-0" onClick={handleLogout}>
      {isLoading ? t('edit_profile.logging_out') : t('edit_profile.logout')}
    </Button>
  );
}
